export default __webpack_public_path__ + "static/schneider-f2c8ea2ac4e3f9248ed887b4436f292e.jpg";